export default __webpack_public_path__ + "static/media/illu-fond.4bd67389.svg";